<div class="speed-layout d-flex justify-content-center align-items-stretch">
  <div class="speed-card d-flex flex-column w-100">
    <!-- Header: titulo y checkbox -->
    <div class="speed-header" [ngClass]="{'background-header': !view_old_title}">
      <h4 class="mb-0">{{ "content-device-speed.sprinkler-speed" | translate }}</h4>
      <div class="center">
        <app-loading-status [status]="loading.status_speed"></app-loading-status>
        <div class="form-check p-0 ml-2">
          <label class="switch m-0">
            <input
              type="checkbox"
              [value]="enabledDisabledSpeed"
              [checked]="enabledDisabledSpeed"
              (change)="changeStatusSpeed(enabledDisabledSpeed)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Body: radios arriba e inputs abajo -->
    <div
      class="speed-body d-flex flex-wrap justify-content-center animated animate__fadeIn w-100"
      [ngClass]="{'pr-2 pl-2': !view_old_title}"
    >
      <!-- Body top: modo de velocidad -->
      <div class="speed-mode d-flex w-100">
        <div class="form-check mr-2 c-pointer">
          <input
            class="form-check-input"
            type="radio"
            name="speed_radio"
            id="input_status_speed"
            [checked]="!view_speed_orbital"
            (change)="changeInput('status_speed')"
          />
          <label class="form-check-label" for="input_status_speed"> {{ "speed-config.normal" | translate }} </label>
        </div>
        <div class="form-check c-pointer" (click)="changeInput('orbital')">
          <input
            class="form-check-input"
            type="radio"
            name="speed_radio"
            id="speed_orbital"
            [checked]="view_speed_orbital"
            (change)="changeInput('orbital')"
          />
          <label class="form-check-label" for="speed_orbital"> {{ "speed-config.orbital" | translate }} </label>
        </div>
      </div>

      <!-- Body bottom: inputs por modo -->
      <div class="speed-inputs d-flex flex-column" *ngIf="!view_speed_orbital">
        <div class="speed-input-group">
          <div class="d-flex align-items-center">
            <input
              class="w-100 speed-range"
              type="range"
              list="list_status_speed"
              max="100"
              min="37.5"
              step="12.5"
              [(ngModel)]="feeder.status_speed"
              name="status_speed"
              id="status_speed"
            />
            <datalist id="list_status_speed">
              <option
                *ngFor="let item of optionSpeed;"
                [value]="item"
                [label]="item + '%'"
              ></option>
            </datalist>
          </div>
          <div class="speed-scale d-flex justify-content-between">
            <span *ngFor="let item of optionSpeed;">{{item}}</span>
          </div>
        </div>
      </div>

      <div class="speed-inputs d-flex flex-column" *ngIf="view_speed_orbital">
        <div class="speed-input-group">
          <label class="speed-label mb-1">{{ "speed-config.high" | translate }}</label>
          <div class="d-flex align-items-center">
            <input
              class="w-100 speed-range"
              type="range"
              list="list_status_high_speed"
              max="100"
              min="37.5"
              step="12.5"
              [(ngModel)]="feeder.status_high_speed"
              name="status_high_speed"
              id="status_high_speed"
            />
            <datalist id="list_status_high_speed">
              <option
                *ngFor="let item of optionSpeed;"
                [value]="item"
                [label]="item + '%'"
              ></option>
            </datalist>
          </div>
          <div class="speed-scale d-flex justify-content-between">
            <span *ngFor="let item of optionSpeed;">{{item}}</span>
          </div>
        </div>

        <div class="speed-input-group">
          <label class="speed-label mb-1">{{ "speed-config.low" | translate }}</label>
          <div class="d-flex align-items-center">
            <input
              class="w-100 speed-range"
              type="range"
              list="list_status_low_speed"
              max="100"
              min="37.5"
              step="12.5"
              [(ngModel)]="feeder.status_low_speed"
              name="status_low_speed"
              id="status_low_speed"
            />
            <datalist id="list_status_low_speed">
              <option
                *ngFor="let item of optionSpeed;"
                [value]="item"
                [label]="item + '%'"
              ></option>
            </datalist>
          </div>
          <div class="speed-scale d-flex justify-content-between">
            <span *ngFor="let item of optionSpeed;">{{item}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer: botones de accion -->
    <div class="speed-footer mb-2">
      <div class="speed-actions d-flex flex-column align-items-center">
        <button class="btn btn-primary mb-2" (click)="sendValue()">{{ "content-device-speed.send-values" | translate }}</button>
        <button class="btn btn-secondary" (click)="getSpeed()">
          <app-loading-status [status]="loading.get_speed"></app-loading-status>
          {{ "speed-config.request-status" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
